import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RootDashboard from '../../layouts/Root';

const App: React.FC = () => {
  return (
    <Router>
      <RootDashboard></RootDashboard>
    </Router>
  );
};

export default App;
